module.exports = __webpack_public_path__ + "static/img/service1.9d0dc6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service1.jpg
// module id = VUqY
// module chunks = 0